import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
  IconButton,
  InputAdornment,
  Button,
  Paper,
  Typography,
  useTheme,
} from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import { toast } from "react-toastify";
import TwilioInstructionsModal from "../TwilioInstructionsModal";

const TwilioConnectModal = ({ open, onClose, whatsAppId }) => {
  const theme = useTheme();

  const [accountSid, setAccountSid] = useState("");
  const [authToken, setAuthToken] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [showInstructions, setShowInstructions] = useState(false);
  const [showToken, setShowToken] = useState(false);
  
  const handleConnect = async () => {
    try {
      await api.post(`/twiliosession/${whatsAppId}`, {
        accountSid,
        authToken,
        phoneNumber,
      });

      toast.success("Conectado exitosamente con Twilio.");
      setShowInstructions(true);
      onClose();
    } catch (err) {
      toastError(err);
    }
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle
          style={{
            borderBottom: `1px solid ${theme.palette.divider}`,
          }}
        >
          {i18n.t("twilioConnect.title")}
        </DialogTitle>
        <DialogContent style={{ padding: 24 }}>
          <Paper elevation={0}>
            <Typography variant="subtitle1" gutterBottom>
              {i18n.t("twilioConnect.instructions")}
            </Typography>
            <TextField
              label="Account SID"
              fullWidth
              margin="dense"
              value={accountSid}
              onChange={(e) => setAccountSid(e.target.value)}
            />
            <TextField
              label="Auth Token"
              fullWidth
              margin="dense"
              type={showToken ? "text" : "password"}
              value={authToken}
              onChange={(e) => setAuthToken(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowToken(!showToken)}
                      edge="end"
                    >
                      {showToken ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              label="Número de Teléfono"
              fullWidth
              margin="dense"
              placeholder="+1234567890"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
            />

            <Button
              variant="contained"
              color="primary"
              onClick={handleConnect}
              disabled={!accountSid || !authToken || !phoneNumber}
              style={{ marginTop: 16 }}
            >
              {i18n.t("twilioConnect.connectButton") || "Conectar"}
            </Button>
          </Paper>
        </DialogContent>
      </Dialog>

      <TwilioInstructionsModal
        open={showInstructions}
        onClose={() => setShowInstructions(false)}
        accountSids={accountSid ? [accountSid] : []}
      />
    </>
  );
};

export default React.memo(TwilioConnectModal);
